<template>
  <div class="main">
    <report-top
      ><template slot="search">
        <ly-search
          v-model="searchItem.keyword"
          @search="search"
        ></ly-search> </template
    ></report-top>
    <div id="formTable">
      <div class="formTableItem">
        <p class="label">单位筛选</p>
        <selectAlotGroup
          placement="left"
          @groupIdList="
            searchItem.groupIdList = $event;
            getList();
          "
        ></selectAlotGroup>
      </div>
      <div id="ddas">
        <Button @click="exportAll" icon="md-download">导出</Button>
        <Button @click="openAdd" type="primary" size="small" icon="md-add"
          >新增</Button
        >
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="openForm"
      :title="isAdd ? '新增司机' : '编辑司机'"
      footer-hide
      width="900"
      height="400"
      @on-cancel="cliclCancelBtn"
    >
      <Form ref="item" :model="item" :rules="ruleValidate" :label-width="80">
        <Row :gutter="16">
          <Col span="8">
            <FormItem label="姓名" prop="name">
              <Input
                v-model="item.name"
                maxlength="18"
                show-word-limit
                placeholder="请输入"
              />
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="所属部门" prop="groupName">
              <selectGroup
                :name="item.groupName"
                @update:name="item.groupName = $event"
                :id="item.groupId"
                @update:id="item.groupId = $event"
              >
              </selectGroup>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="绑定账号" prop="userName">
              <selectUser
                :name="item.userName"
                @update:name="item.userName = $event"
                :id="item.userId"
                @update:id="item.userId = $event"
              >
              </selectUser>
            </FormItem>
          </Col>

          <Col span="8">
            <FormItem label="绑定车辆" prop="carNo">
              <Input
                v-model="item.carNo"
                @on-focus="openCar = true"
                placeholder="选择车辆"
              ></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="电话" prop="tel">
              <Input
                v-model="item.tel"
                maxlength="11"
                show-word-limit
                type="number"
                placeholder="请输入"
              />
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="其他联系方式" prop="contact">
              <Input
                v-model="item.contact"
                maxlength="18"
                show-word-limit
                placeholder="请输入"
              />
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="身份证号" prop="idCard">
              <Input
                v-model="item.idCard"
                maxlength="18"
                show-word-limit
                placeholder="请输入"
              />
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="性别" prop="sex">
              <Select v-model="item.sex">
                <Option
                  v-for="(x, index) in $t('sex')"
                  :value="index"
                  :key="index"
                  >{{ x }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="年龄" prop="age">
              <InputNumber :min='0' :max='99' v-model="item.age" style="width:100%"></InputNumber>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="职位" prop="job">
              <Input v-model="item.job" placeholder="请输入" />
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="住址" prop="address">
              <Input v-model="item.address" placeholder="请输入" />
            </FormItem>
          </Col>
          <Col span="8" v-if="false">
            <FormItem label="照片" prop="avatar">
              <ly-photo
                ref="lyphoto"
                :limit="1"
                v-model="item.avatar"
              ></ly-photo>
            </FormItem>
          </Col>


          
          <Col span="8">
            <FormItem label="从业资格证号" prop="dqcNo">
              <Input
                maxlength="18"
                show-word-limit
                v-model="item.dqcNo"
              ></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="服务期限" prop="serverTerm">
              <Input v-model="item.serverTerm"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="驾驶证号" prop="licenseNo">
              <Input
                maxlength="18"
                show-word-limit
                v-model="item.licenseNo"
              ></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="入职日期" prop="licenseNo">
              <DatePicker
                type="date"
                placeholder="请选择"
                v-model="item.entryDate1"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="驾驶证到期日期" prop="licenseNo">
              <DatePicker
                type="date"
                placeholder="请选择"
                v-model="item.licenseValidTime1"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="驾驶证年审日期" prop="licenseNo">
              <DatePicker
                type="date"
                placeholder="请选择"
                v-model="item.licenseArTime1"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="状态" prop="signState">
              <Select v-model="item.signState">
                <Option
                  v-for="(x, index) in $t('signState')"
                  :value="index"
                  :key="index"
                  >{{ x }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="备注" prop="remark">
              <Input
                type="textarea"
                v-model="item.remark"
                placeholder="请输入"
              ></Input>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Col span="24">
            <div class="btn-wrap">
              <Button @click="resetForm">重置表单</Button>
              <Button type="primary" @click="addUpdate('item')"
                >提交表单</Button
              >
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
    <Drawer
      title="请选择车辆"
      placement="left"
      :closable="true"
      v-model="openCar"
      draggable
      class="my-drawer"
      width="450"
    >
      <carTool @car="reCar"></carTool>
    </Drawer>
    <fujian ref="fujian"></fujian>
  </div>
</template>
<script>
import axios from "axios";
import fujian from "./fujian.vue";
export default {
  components: { fujian },
  data() {
    return {
      openCar: false,
      openForm: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },

        {
          title: "姓名",
          key: "name",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "账号",
          key: "userAccount",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "绑定车辆",
          key: "carNo",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "所属单位",
          key: "groupName",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "入职日期",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.entryDate, "yymmdd"));
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "驾驶证到期日期",
          render: (h, data) => {
            return h(
              "div",
              this.utils.time(data.row.licenseValidTime, "yymmdd")
            );
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "驾驶证年审日期",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.licenseArTime, "yymmdd"));
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "身份证号",
          key: "idCard",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "驾驶证号",
          key: "licenseNo",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "从业资格证号",
          key: "dqcNo",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "电话",
          key: "tel",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "其他联系方式",
          key: "contact",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "职位",
          key: "job",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "年龄",
          key: "age",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "服务期限",
          key: "serverTerm",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "性别",
          key: "sex",
          minWidth: 100,
          maxWidth: 200,
          render: (h, data) => {
            return h("div", this.$t("sex." + data.row.sex));
          },
        },
        {
          title: "状态",
          key: "sex",
          minWidth: 100,
          maxWidth: 200,
          render: (h, data) => {
            return h("div", this.$t("signState." + data.row.signState));
          },
        },
        {
          title: "创建者账号",
          key: "createAccount",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "操作",
          slot: "action",
          width: 180,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        groupId: "",
        groupName: "",
        userId: "",
        carId: "",
        carNo: "",
        dqcNo: "", //从业资格证号
        entryDate: "", //入职日期
        entryDate1: new Date(), //入职日期
        licenseArTime: "", //驾驶证年审日期
        licenseArTime1: new Date(), //驾驶证年审日期
        licenseNo: "", //驾驶证号
        licenseValidTime: "", //驾驶证到期
        licenseValidTime1: new Date(), //驾驶证到期
        serverTerm: "", //服务期限
        sex: "0",
        signState: "1", //0--解约 1--签约
      },
      ruleValidate: {
        driverNo: { required: true, message: "必填" },
        name: { required: true, message: "必填" },
        groupName: { required: true, message: "必填" },
        model: { required: true, message: "必填" },
        type: { required: true, message: "必填" },
      },
      searchItem: {
        keyword: "",
        pageSize: 50,
        pageNumber: 1,
        groupIdList:[]
      },
      total: 0,
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.dm + "/driver/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (const i in data) {
          data[i].entryDate1 = this.utils.sjcTo(data[i].entryDate);
          data[i].licenseArTime1 = this.utils.sjcTo(data[i].licenseArTime);
          data[i].licenseValidTime1 = this.utils.sjcTo(
            data[i].licenseValidTime
          );
          data[i].signState = String(data[i].signState);
          data[i].sex=String(data[i].sex)
        }
        this.tableData = data;
        console.log(data);
      });
    },
    exportAll() {
      var params = [
        {
          name: "keyword",
          value: this.searchItem.keyword,
        },
        {
          name: "groupIdList",
          value: this.searchItem.groupIdList,
        },
      ];
      this.utils.exportData(axios.dm + "/driver/export", params);
    },
    addUpdate(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.item.entryDate = this.utils.toSjc(this.item.entryDate1);
          this.item.licenseArTime = this.utils.toSjc(this.item.licenseArTime1);
          this.item.licenseValidTime = this.utils.toSjc(
            this.item.licenseValidTime1
          );
          if (this.isAdd) {
            axios({
              method: "post",
              url: axios.dm + "/driver/add",
              data: this.item,
            }).then((res) => {
              console.log(res);
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          } else {
            axios({
              method: "post",
              url: axios.dm + "/driver/update",
              data: this.item,
            }).then((res) => {
              if (res) {
                this.openForm = false;
                this.getList();
              }
            });
          }
        }
      });
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.dm + "/driver/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.openForm = true;
      this.isAdd = false;
      this.item = row;
    },
    openAdd() {
      this.openForm = true;
      this.isAdd = true;
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    cliclCancelBtn() {
      this.openForm = false;
      var arr = this.tableData;
      this.tableData = [];
      setTimeout(() => {
        this.tableData = arr;
      }, 200);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    reCar(v) {
      this.openCar = false;
      this.item.carId = v.id;
      this.item.carNo = v.carNo;
    },
    search() {
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/information/driver.vue